import { useState, useEffect } from 'react'
import TopBar from '../../../components/TopBar'
import { getOption, updateOption } from '../../../api/optionsApi'
import styles from '../page.module.css'

const MenuHeader = () => {
    const [headerAdditionalInfo, setHeaderAdditionalInfo] = useState({
        leftContent: "",
        rightContent: ""
    });
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const loadData = async () => {

            try {
                const data = await getOption("header-topbar");
                setHeaderAdditionalInfo(data.data.value);
            } catch (error) {
                console.error("Error loading data:", error);
            }
        };
        loadData();

    }, []);

    const handleSave = async () => {
        setIsLoading(true)
        try {
            await updateOption("header-topbar", headerAdditionalInfo);
            
        } catch (error) {
            console.error("Error saving:", error);            
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <TopBar />
            <div className={styles.appearanceMenuSection}>
                <div className={styles.appearanceMenuBox}>
                    <div className={styles.appearanceMenuBlock}>
                        <div className={styles.appearanceMenuLeft}>
                            <div className={styles.appearanceMenuWidgetBlock}>
                                <label className={styles.appearanceMenuBoxLabel}>Top Bar – Left Side Content</label>
                                <p className={styles.appearanceMenuDescription}>
                                    This content appears on the <strong>left side of the top bar</strong> on the website.
                                    You may use <strong>HTML</strong> such as links, icons, or formatting.
                                </p>
                                <textarea
                                    className={styles.appearanceMenuTextArea}
                                    value={headerAdditionalInfo.leftContent}
                                    onChange={(e) =>
                                        setHeaderAdditionalInfo({
                                            ...headerAdditionalInfo,
                                            leftContent: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className={styles.appearanceMenuRight}>
                            <div className={styles.appearanceMenuWidgetBlock}>
                                <label className={styles.appearanceMenuBoxLabel}>Top Bar – Right Side Content</label>
                                <p className={styles.appearanceMenuDescription}>
                                    This content appears on the <strong>right side of the top bar</strong>.
                                    You may use <strong>HTML</strong> for buttons, links, or icons.
                                </p>
                                <textarea
                                    className={styles.appearanceMenuTextArea}
                                    value={headerAdditionalInfo.rightContent}
                                    onChange={(e) =>
                                        setHeaderAdditionalInfo({
                                            ...headerAdditionalInfo,
                                            rightContent: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.saveButtons}>
                        <button className={`${styles.saveButton} ${styles.saveChangeButton}`} onClick={() => handleSave()}>
                            {isLoading ? <div className='ringLoader'></div> : 'Save Changes'}
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

export default MenuHeader
